const e=async(e,t,n,r)=>{let{data:i}=await e.put(`/apps/${t}/email-template/${n}`,r);return i};export{e as updateEmailTemplate};
//# sourceMappingURL=update-email-template.mjs.map